import { render, staticRenderFns } from "./CustomerTempCredit.vue?vue&type=template&id=47162148"
import script from "./CustomerTempCredit.vue?vue&type=script&lang=js"
export * from "./CustomerTempCredit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports